import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=0b2324b8&scoped=true"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=0b2324b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2324b8",
  null
  
)

export default component.exports